import { render } from "./specifications.vue?vue&type=template&id=9671e036"
import script from "./specifications.vue?vue&type=script&lang=js"
export * from "./specifications.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__